module.exports = __webpack_public_path__ + "img/vvs.f3ae8622.svg";